module.exports = __webpack_public_path__ + "static/media/undercarriage-icon.a5d58424.png";